import React, {useEffect, useState} from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import {Delete} from '../../../assets/Icons/CreditAdviceIcons';
import {toDateString} from '../../../services/DateUtils';
import {withStyles} from '@mui/styles';
import Checkbox from '@mui/material/Checkbox';
import {departmentService} from '../../department/services/DepartmentService';
import SpinnerInline from '../../../components/Spinner/SpinnerInline';
import {PriceCurrencyLiteral} from '../../../services/MoneyUtils';
import {TextareaAutosize} from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import TextField from '@mui/material/TextField';
import * as validationUtils from '../../../services/ValidationUtils';
import Select from '@mui/material/Select';
import {PricingModel} from '../../vendor/models/PricingModel';
import MenuItem from '@mui/material/MenuItem';

const checkBoxStyles = () => ({
  root: {
    '&$checked': {
      color: '#FF0954',
    },
  },
  checked: {},
});

const CustomCheckbox = withStyles(checkBoxStyles)(Checkbox);

const CreditLineItem = React.memo((props) => {
  const {
    creditLineItem,
    index,
    isLocked,
    isSelected,
    handleSelectItem,
    handleDeleteCreditLineItem,
    handleEditCreditLineItemCaption,
    handleEditCreditLineItemPrice
  } = props;
  const [loadingDepartment, setLoadingDepartment] = useState(true);
  const [localCreditLineItem, setLocalCreditLineItem] = useState(creditLineItem);
  const [isCaptionInEditMode, setIsCaptionInEditMode] = useState(false)
  const [caption, setCaption] = useState(creditLineItem.caption)
  const [isPriceInEditMode, setIsPriceInEditMode] = useState(false)
  const [priceValue, setPriceValue] = useState(creditLineItem.price.value)
  const departmentKey = creditLineItem.department.departmentKey;

  useEffect(() => {
    if (departmentKey) {
      departmentService.fetchDepartmentByKeyCached(departmentKey)
        .then(response => {
          setLocalCreditLineItem((localCreditLineItem) => ({
            ...localCreditLineItem,
            department: {
              departmentKey: departmentKey,
              name: response.name
            }
          }));
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          setLoadingDepartment(false);
        });
    } else {
      setLocalCreditLineItem((localCreditLineItem) => ({
        ...localCreditLineItem,
        department: {
          departmentKey: departmentKey,
          name: 'Ressort noch nicht ermittelt'
        }
      }));
    }
  }, [departmentKey, creditLineItem.department.name]);

  const handleCaptionClick = () => {
    !isLocked && setIsCaptionInEditMode(true)
  }

  const handleCaptionClickAway = () => {
    if (caption && (caption !== creditLineItem.caption)) {
      handleEditCreditLineItemCaption(creditLineItem, caption)
    }
    setIsCaptionInEditMode(false)
  };

  const handlePriceClick = () => {
    !isLocked && setIsPriceInEditMode(true)
  }

  const handlePriceClickAway = () => {
    if (priceValue && (priceValue !== creditLineItem.price.value)) {
      handleEditCreditLineItemPrice(creditLineItem, priceValue);
    }
    setIsPriceInEditMode(false);
  };

  const handlePriceValueChange = (event) => {
    const value = event.target.value.replace('.', ',');
    if (validationUtils.checkIfAllowedInput(value)) {
      setPriceValue(value);
    }
  };

  return (
    <TableRow
      key={index}
      hover={true}
      data-testid="creditadvicedetail--creditLineItem"
    >
      <TableCell className="creditadvicedetail__actions">
        <CustomCheckbox
          className="creditadvicedetail__checkbox"
          data-testid="creditadvicedetail--checkbox"
          disabled={isLocked}
          checked={isSelected(creditLineItem)}
          onClick={() => handleSelectItem(creditLineItem)}
          inputProps={{'aria-labelledby': creditLineItem.id}}
        />
        {!isLocked ? (
          <span
            className="creditadvicedetail__delete"
            data-testid="creditadvicedetail--delete"
            onClick={
              (event) => {
                event.stopPropagation();
                return handleDeleteCreditLineItem(creditLineItem);
              }
            }
          >
            <Delete/>
          </span>
        ) : (
          <span className="creditadvicedetail__delete--disabled" data-testid="creditadvicedetail--delete__disabled">
            <Delete/>
          </span>
        )}
      </TableCell>
      <TableCell>
        <span
          data-testid="creditadvicedetail--id">{creditLineItem.assetId.originDamId || '-'} / {creditLineItem.foreignId || '-'}</span>
      </TableCell>
      <TableCell>

        <div className="creditadvicedetail__heading" data-testid="creditadvicedetail--caption"
             onClick={handleCaptionClick}> {isCaptionInEditMode ?
          <ClickAwayListener onClickAway={handleCaptionClickAway}>
            <TextareaAutosize
              data-testid="creditadvicedetail--caption__textarea"
              id="headline"
              variant="outlined"
              type="text"
              value={caption}
              minRows={3}
              maxLength={2048}
              onChange={(e) => {
                setCaption(e.target.value)
              }}
              style={{width: '100%', padding: '8px', fontSize: '15px', maxLength: 500}}
            />
          </ClickAwayListener>
          : <span data-testid="creditadvicedetail--caption__span"> {caption || '-'}</span>
        }
        </div>
      </TableCell>
      <TableCell>
        <span data-testid="creditadvicedetail--department">{loadingDepartment ?
          <SpinnerInline/> : localCreditLineItem.department.name || '-'}</span>
      </TableCell>
      <TableCell>
        <div
          data-testid="creditadvicedetail--usageTime">{toDateString(creditLineItem.usageTime.start) || '-'} - {toDateString(creditLineItem.usageTime.end) || '-'}</div>
      </TableCell>
      <TableCell align="right" className="creditadvicedetail--alignRight">
        <div data-testid="creditadvicedetail--price"
             onClick={handlePriceClick}>
          {isPriceInEditMode ?
            <ClickAwayListener onClickAway={handlePriceClickAway}>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <TextField
                  data-testid="creditadvicedetail__price__textfield"
                  value={priceValue}
                  onChange={handlePriceValueChange}
                  margin="dense"
                  inputProps={{style: {width: '60px'}}}
                />
                <Select
                  data-testid="creditadvicedetail__price__selectfield"
                  value={creditLineItem.price.currency}
                  style={{marginLeft: '8px'}}
                  MenuProps={{disablePortal: true}}
                >
                  <MenuItem key={creditLineItem.price.currency} value={creditLineItem.price.currency}>
                    {PricingModel.Currency[creditLineItem.price.currency]}
                  </MenuItem>
                </Select>
              </div>
            </ClickAwayListener>
            :
            <PriceCurrencyLiteral price={creditLineItem.price.value} currency={creditLineItem.price.currency}
                                  testId="creditadvicedetail--price"/>
          }
        </div>
      </TableCell>
    </TableRow>
  );
});

export default CreditLineItem;
